// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconDealsPath = 'M25.98 13.864 24.5 3.93l-10.1.75c-.88.066-1.7.5-2.247 1.191l-7.47 9.418a3.17 3.17 0 0 0 .516 4.45l8.205 6.5a3.142 3.142 0 0 0 2.332.664 3.147 3.147 0 0 0 2.117-1.179l7.477-9.426a3.179 3.179 0 0 0 .65-2.434Zm-2.217 1.191-7.478 9.427c-.193.244-.47.398-.78.434a1.154 1.154 0 0 1-.859-.244l-8.205-6.5a1.17 1.17 0 0 1-.19-1.64l7.47-9.418c.2-.255.503-.415.827-.439l8.246-.613 1.207 8.097c.048.318-.039.645-.238.896ZM18.46 9.501a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z';
var NavigationIconDeals = baseIcon('NavigationIconDeals', {
  getPath: () => NavigationIconDealsPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconDeals;
//# sourceMappingURL=index.js.map